// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pl-1";
export var messageSideRight = "_pl-2";
export var subscribeToBackInStockBubbleContainer = "_pl-0";